/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Lines_LabelInputs */

const en_editor_filter_lines_label = /** @type {(inputs: Editor_Filter_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lines`)
};

const fr_editor_filter_lines_label = /** @type {(inputs: Editor_Filter_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lignes`)
};

const de_editor_filter_lines_label = /** @type {(inputs: Editor_Filter_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeilen`)
};

const it_editor_filter_lines_label = /** @type {(inputs: Editor_Filter_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righe`)
};

const ru_editor_filter_lines_label = /** @type {(inputs: Editor_Filter_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Строки`)
};

const es_editor_filter_lines_label = /** @type {(inputs: Editor_Filter_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Líneas`)
};

const zh_cn2_editor_filter_lines_label = /** @type {(inputs: Editor_Filter_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行数`)
};

const ja_editor_filter_lines_label = /** @type {(inputs: Editor_Filter_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行数`)
};

const hi_editor_filter_lines_label = /** @type {(inputs: Editor_Filter_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंक्तियाँ`)
};

const pt_pt2_editor_filter_lines_label = /** @type {(inputs: Editor_Filter_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas`)
};

/**
* | output |
* | --- |
* | "Lines" |
*
* @param {Editor_Filter_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_lines_label = /** @type {((inputs?: Editor_Filter_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_lines_label(inputs)
	if (locale === "de") return de_editor_filter_lines_label(inputs)
	if (locale === "it") return it_editor_filter_lines_label(inputs)
	if (locale === "ru") return ru_editor_filter_lines_label(inputs)
	if (locale === "es") return es_editor_filter_lines_label(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_lines_label(inputs)
	if (locale === "ja") return ja_editor_filter_lines_label(inputs)
	if (locale === "hi") return hi_editor_filter_lines_label(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_lines_label(inputs)
	return en_editor_filter_lines_label(inputs)
});